import React, { useState, useEffect, useRef, useContext } from "react";
import {
  View,
  StyleSheet,
  TouchableOpacity,
  Image,
  ScrollView,
  Dimensions,
} from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import CustomText from "../../accessories/CustomText";
import AsyncStorage from "@react-native-async-storage/async-storage";
import * as LocalAuthentication from "expo-local-authentication";
import { SafeAreaView } from "react-native";
import { android, ios } from "../../accessories/Platform";
import { context, DrawerView } from "../../accessories/accessories";
import {
  generateBoxShadowStyle,
  generateFingerprint,
  handleAPI,
  handleCreateNewSession,
  handleGetActiveLoan,
} from "../../accessories/CommonFunctions";
import MaterialIcons from "react-native-vector-icons/MaterialIcons";
import ArrowSpinner from "../../accessories/ArrowSpinner";
import Login from "../../SignIn/Login";
import Signup from "../../SignUp/Signup";
import useKeyboardHeight from "../../accessories/KeyboardHeight";
import packageJson from "../../../package.json";
import { DeviceEventEmitter } from "react-native";
// import BottomSheet from "../../accessories/BottomSlider";
const { version, buildVersion } = packageJson;
export default function StartScreen(props) {
  const { setContextDetails } = useContext(context); //Get value from context
  const { navigation } = props;
  const cardDetails = [
    {
      label: "View today’s interest rates",
      paramsObj: {},
    },
    {
      label: "start a loan application",
      paramsObj: { startNewLoan: true },
    },
    { label: "view your loan status", paramsObj: {} },
    { label: "Make a Payment", paramsObj: {} },
  ];

  const [biometricWebLoginId, setBiometricWebLoginId] = useState(null);
  const [tryLoginWithFace, setTryLoginWithFace] = useState(ios);
  const [userName, setUserName] = useState(null);
  const [drawerDetails, setDrawerDetails] = useState({
    isShow: false,
    body: <></>,
    onClose: () => {},
  });

  const navigate = (navigateTo, paramsObj = {}) => {
    setContextDetails((prevContextDetails) => {
      return { ...prevContextDetails, ...paramsObj, Path: navigateTo };
    });
    navigation.navigate(navigateTo, { ...paramsObj, biometricWebLoginId });
  };
  useEffect(() => {
    handleSettingsDetails();

    return () => {
      setBiometricWebLoginId(null);
    };
  }, [props]);

  useEffect(() => {
    if (!isNaN(parseInt(biometricWebLoginId)) && tryLoginWithFace) {
      setTimeout(() => {
        handleLoginWithBioMetric();
      }, 500);
      setTryLoginWithFace(false);
    }
  }, [biometricWebLoginId]);

  useEffect(() => {
    DeviceEventEmitter.addListener("URLDataReceived", ({ data }) => {
      // Alert.alert(data);
      // console.log('Received data in React Native:', data);
      AsyncStorage.setItem("LoEmpNum", data || null);
    });

    // let params = {
    //   Id: 1,
    // };

    //  handleAPI({
    //   name: "GetPublicIPAddress",
    //   params: params,
    // })
    //   .then(async (response) => {
    //     GetLoanOfficerMappingForIP(response);

    //   })
    //   .catch((err) => console.log("Error from GetPublicIPAddress ====> ", err));

    fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => {
        const ipaddress = data.ip;
        GetLoanOfficerMappingForIP(ipaddress);
        //console.log('Your public IP address is:', data.ip);
      })
      .catch((error) => {
        console.error("Error fetching IP address:", error);
      });

    // Listen for the event sent from AppDelegate
    // const subscription = DeviceEventEmitter.addListener('URLDataReceived', ({ data }) => {
    //   Alert.alert(data);
    //   console.log('Received data in React Native:', data);
    //   AsyncStorage.setItem("LoEmpNum", data || null);
    // });

    // // Clean up subscription when component unmounts
    // return () => subscription.remove();
  }, []);

  const GetLoanOfficerMappingForIP = (IpAddress) => {
    if (IpAddress) {
      let params = {
        IPAddress: IpAddress,
      };
      handleAPI({
        name: "GetLoanOfficerMapping",
        params: params,
      })
        .then(async (response) => {
          AsyncStorage.setItem("LoEmpNum", response || null);
        })
        .catch((err) =>
          console.log("Error from GetPublicIPAddress ====> ", err)
        );
    }
  };
  const SlideCard = () => {
    const [sliderState, setSliderState] = useState({ currentPage: 0 }),
      { width } = Dimensions.get("window"),
      scrollViewRef = useRef(null),
      { currentPage: pageIndex } = sliderState;

    useEffect(() => {
      const intervalId = setInterval(() => {
        setSliderState(({ currentPage: prevPage }) => {
          let newIndex = prevPage + 1 === cardDetails.length ? 0 : prevPage + 1;

          scrollViewRef.current.scrollTo({
            animated: newIndex !== 0,
            x: width * newIndex,
            y: 0,
          });

          return {
            currentPage: prevPage,
          };
        });
      }, 5000);
      return () => {
        clearInterval(intervalId);
      };
    }, []);

    const handleSliderPage = (event) => {
      const { currentPage } = sliderState;
      const { x } = event.nativeEvent.contentOffset;

      let indexOfNextScreen = Math.round(x / width);

      if (indexOfNextScreen !== pageIndex) {
        indexOfNextScreen =
          indexOfNextScreen === cardDetails.length ? 0 : indexOfNextScreen;

        setSliderState(({ currentPage: prevPage }) => {
          let newIndex = prevPage + 1 === cardDetails.length ? 0 : prevPage + 1;
          return {
            currentPage: newIndex,
          };
        });
      }
    };

    return (
      <View style={{ height: 160 }}>
        <SafeAreaView style={{ flex: 1 }}>
          <ScrollView
            style={[generateBoxShadowStyle(2, 6, "black", 0.2, 3, 8, "black")]}
            horizontal={true}
            scrollEventThrottle={16}
            pagingEnabled={true}
            showsHorizontalScrollIndicator={false}
            onScroll={handleSliderPage}
            ref={scrollViewRef}
          >
            {cardDetails.map((card, index) => (
              <View key={index} style={[{ width }]}>
                <View
                  style={[
                    styles.card,
                    { flexDirection: "row" },
                    generateBoxShadowStyle(2, 6, "black", 0.2, 3, 8, "black"),
                  ]}
                >
                  <CustomText
                    fontName="RobotoRegular"
                    bold={true}
                    onPress={() => {
                      navigate("Login", card["paramsObj"]);
                    }}
                    style={[styles.label]}
                  >
                    {card.label}
                  </CustomText>
                </View>
              </View>
            ))}
          </ScrollView>
          <View style={[styles.paginationWrapper]}>
            {Array.from(Array(cardDetails.length).keys()).map((key, index) => (
              <View
                style={[
                  styles.paginationDots,
                  {
                    opacity: pageIndex === index ? 1 : 0.5,
                    backgroundColor:
                      index === pageIndex
                        ? "rgba(255, 255, 255, 0.80)"
                        : "#66BBE9",
                    shadowColor: "rgba(0, 0, 0, 0.25)",
                  },
                  generateBoxShadowStyle(-2, 2, "black", 0.3, 3, 4, "black"),
                ]}
                key={index}
              />
            ))}
          </View>
        </SafeAreaView>
      </View>
    );
  };

  const handleLoginWithBioMetric = async () => {
    try {
      const enroll = await LocalAuthentication.isEnrolledAsync(),
        iBiometricWebLoginId = biometricWebLoginId;
      if (enroll) {
        const biometricAuth = await LocalAuthentication.authenticateAsync({
          promptMessage: `Confirm your ${ios ? "Face" : "Touch"} ID`,
          disableDeviceFallback: true,
          cancelLabel: "Cancel",
        });

        if (biometricAuth.success) {
          setBiometricWebLoginId("Loading");

          let SessionId = await handleCreateNewSession(iBiometricWebLoginId);
          let { activeLoanCount = 1, activeLoanId = -999 } =
            (await handleGetActiveLoan(SessionId)) || {};

          if (activeLoanCount == 1) {
            setContextDetails((prevContextDetails) => {
              return {
                ...prevContextDetails,
                ...{ loanId: activeLoanId },
              };
            });
            navigate("Home", {
              userName,
              SessionId,
              loanId: activeLoanId,
            });
          } else {
            navigate("DashBoard", {
              SessionId,
            });
          }
        }
        setBiometricWebLoginId(iBiometricWebLoginId);
      }
    } catch (error) {
      console.error("Error form handleLoginWithBioMetric ===> ", error);
    }
  };

  const handleSettingsDetails = async () => {
    try {
      let visitorIdOld = JSON.parse(
          (await AsyncStorage.getItem("visitorId")) || null
        ),
        visitorId = null;
      if (visitorIdOld) {
        visitorId = visitorIdOld;
      } else {
        visitorId = generateFingerprint();
        visitorId = `D-${visitorId.replaceAll("-", "")}`;
        await AsyncStorage.setItem(
          "visitorId",
          JSON.stringify(visitorId) || null
        );
      }

      let bioMetricLoginDetails =
        (await AsyncStorage.getItem("bioMetricLoginDetails")) || "[]";
      bioMetricLoginDetails = JSON.parse(bioMetricLoginDetails);

      if (bioMetricLoginDetails.length) {
        const { WebloginId = "", UserName = "" } = bioMetricLoginDetails[0];

        WebloginId && setBiometricWebLoginId(WebloginId);
        UserName && setUserName(UserName);
      } else {
        handleAPI({
          name: "GetSettingsForWebLoginAccount",
          params: { WebLoginId: 0, BioMetric: visitorId },
        })
          .then(async function (response) {
            response = JSON.parse(response)["Table"];

            await AsyncStorage.setItem(
              "bioMetricLoginDetails",
              JSON.stringify(response)
            );

            if (response.length > 0) response = response[0];
            if (response["BioMetricId"])
              setBiometricWebLoginId(response["WebloginId"]);
            else setBiometricWebLoginId(null);

            if (response["UserName"]) setUserName(response["UserName"]);
            else setUserName(null);
          })
          .catch(function (err) {
            console.error(
              `Error from GetSettingsForWebLoginAccount ====>  ${err}`
            );
          });
      }

      // visitorId = "D-1942454078";
    } catch (error) {}
  };
  const handleCloseDrawer = () => {
    setDrawerDetails({
      isShow: false,
      body: <></>,
      onClose: () => {},
    });
  };
  const keyboardHeight = useKeyboardHeight() || 0;
  const handleDrawerView = (
    displayComponent,
    option = {},
    loginType = null
  ) => {
    let body = (
      <>
        {displayComponent == "Login" ? (
          <Login
            loginType={loginType}
            from="startScreen"
            route={{
              params: option,
            }}
            performAction={(path, option) => {
              if (["DashBoard", "Home"].includes(path)) {
                handleCloseDrawer();
                navigate(path, option);
              } else {
                setTimeout(() => {
                  handleDrawerView(path, option);
                }, 0);
              }
            }}
          />
        ) : displayComponent == "Signup" ? (
          <Signup
            navigation={navigation}
            loginType={loginType}
            from="startScreen"
            route={{
              params: option,
            }}
            performAction={(path, option) => {
              if (["DashBoard", "Home"].includes(path)) {
                handleCloseDrawer();
                navigate(path, option);
              } else {
                setTimeout(() => {
                  handleDrawerView(path, option);
                }, 0);
              }
            }}
          />
        ) : (
          <></>
        )}
      </>
    );
    setDrawerDetails({
      bodyName: android ? "android" : displayComponent,
      isShow: true,
      body,
      onClose: () => {
        handleCloseDrawer();
      },
    });
  };

  return (
    <>
      <LinearGradient
        colors={["#66BBE9", "#3478CC", "#204C86"]}
        style={{
          alignItems: "center",
          flex: 1,
          // justifyContent: "space-evenly",
          justifyContent: "flex-start",
        }}
      >
        <Image
          style={{ width: 304, height: 76, marginTop: 100 }}
          source={require("../../../assets/DMLarge1.png")}
          // source={require("../../../assets/StartScreenDM.png")}
        />
        <CustomText
          style={{
            fontSize: 13,
            width: 300,
            color: "#4d4d4d",
            textAlign: "right",
            paddingHorizontal: 15,
            marginTop: -25,
          }}
        >
          {version}
        </CustomText>
        <View
          style={{
            width: "80%",
            flexDirection: "column",
            justifyContent: "space-evenly",
            flex: 1,
          }}
        >
          <View>
            <View
              style={[
                {
                  flexDirection: "row",
                  // width: "80%",
                },
                !userName && {
                  alignSelf: "center",
                },
              ]}
            >
              <CustomText
                bold={true}
                fontName="segoeUIBold"
                style={{
                  paddingBottom: 12,
                  paddingTop: 12,
                  color: "#FFFFFF",
                  fontSize: 40,
                }}
              >
                <>
                  {userName ? (
                    <>
                      Welcome Back
                      {",\n"}
                      {userName}
                      {"."}
                    </>
                  ) : (
                    "Welcome!"
                  )}
                </>
              </CustomText>
            </View>

            <View
              style={{
                minHeight: 100,
                alignSelf: "center",
                justifyContent: "flex-end",
              }}
            >
              {biometricWebLoginId && (
                <TouchableOpacity onPress={handleLoginWithBioMetric}>
                  <View>
                    {biometricWebLoginId === "Loading" ? (
                      <View style={{ height: 50 }}>
                        <ArrowSpinner
                          isSpinner={true}
                          size={48}
                          color="#fff"
                          duration={1500}
                          style={{ height: 50 }}
                        />
                      </View>
                    ) : (
                      <>
                        {android ? (
                          <MaterialIcons
                            name="fingerprint"
                            color="#fff"
                            size={48}
                          />
                        ) : (
                          <>
                            <View>
                              <Image
                                resizeMode="stretch"
                                style={{
                                  width: 60,
                                  height: 60,
                                }}
                                source={require("../../../assets/FaceId.png")}
                              />
                            </View>
                          </>
                        )}
                      </>
                    )}
                  </View>
                </TouchableOpacity>
              )}
            </View>
          </View>

          <View style={{ marginTop: -30 }}>
            <CustomText
              fontName="segoeUIBold"
              style={{
                paddingVertical: 12,
                color: "#FFFFFF",
                fontSize: 17,
                textTransform: "capitalize",
                alignSelf: "center",
                justifyContent: "center",
              }}
            >
              Getting a mortgage just got easier
            </CustomText>

            <View style={{ width: "100%" }}>
              <View style={styles.container}>
                <View>
                  <TouchableOpacity
                    activeOpacity={0.8}
                    onPress={() => {
                      handleDrawerView("Login");
                    }}
                  >
                    <Image
                      style={{
                        width: 70,
                        height: 70,
                      }}
                      source={require("../../../assets/CreateAccount.png")}
                    />
                  </TouchableOpacity>
                  <CustomText
                    fontName="RobotoRegular"
                    onPress={() => {
                      handleDrawerView("Login");
                    }}
                    style={{
                      color: "#FFFFFF",
                      textAlign: "center",
                      fontSize: 14,
                    }}
                  >
                    Create an{"\n"}Account
                  </CustomText>
                </View>

                <View>
                  <TouchableOpacity
                    activeOpacity={0.8}
                    onPress={() => {
                      handleDrawerView("Login");
                    }}
                  >
                    <Image
                      style={{
                        width: 70,
                        height: 70,
                      }}
                      source={require("../../../assets/AboutYou.png")}
                    />
                  </TouchableOpacity>
                  <CustomText
                    fontName="RobotoRegular"
                    onPress={() => {
                      handleDrawerView("Login");
                    }}
                    style={{
                      color: "#FFFFFF",
                      textAlign: "center",
                      fontSize: 14,
                    }}
                  >
                    eSign{"\n"}Documents
                  </CustomText>
                </View>

                <View>
                  <TouchableOpacity
                    activeOpacity={0.8}
                    onPress={() => {
                      handleDrawerView("Login", {}, "secureDoc");
                    }}
                  >
                    <Image
                      style={{
                        width: 70,
                        height: 70,
                      }}
                      source={require("../../../assets/UploadDoc.png")}
                    />
                  </TouchableOpacity>
                  <CustomText
                    fontName="RobotoRegular"
                    onPress={() => {
                      handleDrawerView("Login", {}, "secureDoc");
                    }}
                    style={{
                      color: "#FFFFFF",
                      textAlign: "center",
                      fontSize: 14,
                    }}
                  >
                    Upload{"\n"}Documents
                  </CustomText>
                </View>
              </View>

              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "center",
                  position: "absolute",
                  width: "100%",
                  top: "43%",
                }}
              >
                <Image
                  resizeMode="stretch"
                  source={require("../../../assets/FrameMenuLine.png")}
                />
              </View>
            </View>
          </View>

          <TouchableOpacity
            activeOpacity={0.7}
            style={[
              {
                backgroundColor: "white",
                borderRadius: 8,
                borderWidth: 2,
                borderColor: "#1A3971",
                width: "60%",
                alignSelf: "center",
                alignItems: "center",
                paddingVertical: 5,
              },
              generateBoxShadowStyle(
                -2,
                ios ? 8 : 20,
                "black",
                0.2,
                3,
                4,
                "black"
              ),
            ]}
            onPress={() => {
              handleDrawerView("Login");
            }}
          >
            <CustomText
              fontName="RobotoRegular"
              onPress={() => {
                handleDrawerView("Login");
              }}
              style={{
                paddingVertical: 8,
                // paddingHorizontal: 60,
                color: "#204C86",
                fontSize: 15,
              }}
            >
              Get Started
            </CustomText>
          </TouchableOpacity>
        </View>
      </LinearGradient>
      <DrawerView
        bodyName={drawerDetails["bodyName"]}
        bodyStyle={{
          ...{ paddingHorizontal: 0 },
        }}
        isShow={drawerDetails["isShow"]}
        body={
          <View
            style={{
              maxHeight: Dimensions.get("screen").height / 1.4,
              minHeight: Dimensions.get("screen").height / 1.4,
              flex: 1,
              flexDirection: "row",
            }}
          >
            {drawerDetails["body"]}
          </View>
        }
        onClose={() => {
          setDrawerDetails({
            isShow: false,
            body: <></>,
            onClose: () => {},
          });
        }}
        From="StartScreen"
      />
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 20,
    zIndex: 1,
  },

  card: {
    marginVertical: 10,
    alignSelf: "center",
    backgroundColor: "#598cca",
    borderRadius: 14,
    overflow: "hidden",
    justifyContent: "center",
    alignItems: "center",
    marginHorizontal: 6,
    width: 250,
  },
  shadowProp: {
    shadowColor: "#000",
    shadowOffset: { width: -2, height: 3 },
    shadowOpacity: 0.3,
    shadowRadius: 3,
  },
  label: {
    color: "#fff",
    fontSize: 18,
    // fontFamily: "Roboto",
    // fontWeight: "800",
    textTransform: "capitalize",
    textAlign: "center",
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 32,
    paddingBottom: 32,
  },
  paginationWrapper: {
    justifyContent: "center",
    // alignItems: "center",
    flexDirection: "row",
  },
  paginationDots: {
    height: 12,
    width: 12,
    borderRadius: 12 / 2,
    backgroundColor: "#0898A0",
    marginRight: 10,
  },
});
